import React from 'react';
import Routes from './routes';
import './global.css';


export default function App() {

  return(

    <Routes/>

  ) ;
}

